/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_variation = /** @type {(inputs: {}) => string} */ () => {
	return `Variace`
};

const da_variation = /** @type {(inputs: {}) => string} */ () => {
	return `Variant`
};

const de_variation = /** @type {(inputs: {}) => string} */ () => {
	return `Variante`
};

const en_variation = /** @type {(inputs: {}) => string} */ () => {
	return `Variation`
};

const es_variation = /** @type {(inputs: {}) => string} */ () => {
	return `Variante`
};

const fr_variation = /** @type {(inputs: {}) => string} */ () => {
	return `Variation`
};

const hu_variation = /** @type {(inputs: {}) => string} */ () => {
	return `Variáció`
};

const it_variation = /** @type {(inputs: {}) => string} */ () => {
	return `Variante`
};

const nl_variation = /** @type {(inputs: {}) => string} */ () => {
	return `Variatie`
};

const pl_variation = /** @type {(inputs: {}) => string} */ () => {
	return `Wariant`
};

const pt_variation = /** @type {(inputs: {}) => string} */ () => {
	return `Variação`
};

const sv_variation = /** @type {(inputs: {}) => string} */ () => {
	return `Variant`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const variation = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.variation(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("variation", locale)
	if (locale === "cs") return cs_variation(inputs)
	if (locale === "da") return da_variation(inputs)
	if (locale === "de") return de_variation(inputs)
	if (locale === "en") return en_variation(inputs)
	if (locale === "es") return es_variation(inputs)
	if (locale === "fr") return fr_variation(inputs)
	if (locale === "hu") return hu_variation(inputs)
	if (locale === "it") return it_variation(inputs)
	if (locale === "nl") return nl_variation(inputs)
	if (locale === "pl") return pl_variation(inputs)
	if (locale === "pt") return pt_variation(inputs)
	return sv_variation(inputs)
};